"use client";

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { HiChevronDown } from "react-icons/hi2";
import { cn } from "@repo/lib";
import { useEffect, useRef, useState } from "react";
export function RefineByItemDropdown(t0) {
  const $ = _c(19);
  const {
    active,
    children,
    className
  } = t0;
  const [openSelect, setOpenSelect] = useState(false);
  const ref = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          setOpenSelect(false);
        }
      };
      window.addEventListener("click", handleClickOutside);
      return () => window.removeEventListener("click", handleClickOutside);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== className) {
    t3 = cn("relative", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== openSelect) {
    t4 = () => {
      setOpenSelect(!openSelect);
    };
    $[4] = openSelect;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== active) {
    t5 = <div>{active}</div>;
    $[6] = active;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HiChevronDown className="h-4 rotate-90" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5) {
    t7 = <div className="flex w-full items-center justify-between rounded-xs border border-background/30 px-4 py-2 text-sm dark:border-foreground/30" onClick={t4}>{t5}{t6}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== openSelect) {
    t8 = openSelect && <ul onClick={() => {
      setOpenSelect(false);
    }} className="absolute z-40 w-full rounded-b-md bg-background p-4 shadow-md">{children}</ul>;
    $[12] = children;
    $[13] = openSelect;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t7 || $[17] !== t8) {
    t9 = <nav className={t3} ref={ref}>{t7}{t8}</nav>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}